export default "__VITE_ASSET__B$1Nx8t1__"